export default __webpack_public_path__ + "static/media/vlastiveda.3f8a9337.svg";